import React from 'react';
import { EditButton, Datagrid, TextField, FunctionField } from 'react-admin';
import TList from '../../components/wrapper/TList';
import { AddressField } from '../../components/fields';

const BusinessContractList = props => (
	<TList exporter={false} {...props} sort={{ field: 'creationDateTime', order: 'DESC' }}>
		<Datagrid>
			<EditButton />
			<TextField source="id" sortable={false} />
			<TextField source="subsidiaryId" sortable={false} />
			<TextField source="type" sortable={false} />
			<TextField source="paymentMethodName" sortable={false} />
			<TextField source="status" sortable={false} />
			<FunctionField
				source="comment"
				render={record => (
					<span>
						{record.comment}
						<br />
						<AddressField source="address" record={record} />
					</span>
				)}
				sortable={false}
			/>
			<FunctionField
				source="qualifier1"
				render={record => (
					<span>
						{record.qualifier1}
						<br />
						{record.qualifier2}
					</span>
				)}
				sortable={false}
			/>
		</Datagrid>
	</TList>
);

export default BusinessContractList;
